



// Jquery 
$(document).ready(function () {
  // Watch Swatch Switcher & Smooth Cart Integration
  // Programmatically re-select the active currency in the currency app (BUCKS / Doubly / Shopify)
  function reselectActiveCurrency() {
    var activeCurrency = (
      $('.bucks-selected').first().text().trim() ||
      localStorage.getItem('bucks_current_currency') ||
      localStorage.getItem('currency') ||
      sessionStorage.getItem('currency') ||
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
      'USD'
    ).toUpperCase();

    // 1. Find the active currency option inside BUCKS custom dropdown
    var $bucksOptions = $(
      '.buckscc-select-options li, .buckscc-currency-box li, .hxoSelectTheme ul li, ul.buckscc-options li'
    );

    if ($bucksOptions.length) {
      var $matchedOption = $bucksOptions.filter(function () {
        var txt = $(this).text().trim().toUpperCase();
        var val = (
          $(this).attr('data-value') ||
          $(this).attr('data-currency') ||
          $(this).attr('rel') ||
          ''
        ).toUpperCase();
        return (
          val === activeCurrency ||
          txt.indexOf(activeCurrency) !== -1 ||
          $(this).hasClass('active') ||
          $(this).hasClass('selected')
        );
      }).first();

      if ($matchedOption.length) {
        var domEl = $matchedOption[0];
        try {
          var clickEvt = new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window
          });
          domEl.dispatchEvent(clickEvt);
        } catch (e) {
          $matchedOption.trigger('click');
        }
      }
    }

    // 2. Trigger standard currency selects if present
    var $selects = $(
      '#bucksSelector, select.buckcc, .buckscc-currency-box select, select.currency-picker, [name="currencies"]'
    );
    if ($selects.length) {
      $selects.val(activeCurrency).trigger('change');
    }

    // 3. Trigger global currency event hooks
    document.dispatchEvent(new CustomEvent('currency:updated', { detail: { currency: activeCurrency } }));
    document.dispatchEvent(new CustomEvent('currency:change', { detail: { currency: activeCurrency } }));
    if (window.jQuery) {
      jQuery(document.body).trigger('currency:updated');
    }

    // 4. Native app convert fallback calls
    try {
      if (window.bucksCC && typeof window.bucksCC.convert === 'function') window.bucksCC.convert();
      if (window.bucks && typeof window.bucks.convert === 'function') window.bucks.convert();
      if (window.bucksCC && typeof window.bucksCC.init === 'function') window.bucksCC.init();
      if (window.bucks && typeof window.bucks.init === 'function') window.bucks.init();
    } catch (err) { }
  }

  window.reselectActiveCurrency = reselectActiveCurrency;

function formatShowcasePrice(priceCents, defaultFormattedPrice) {
  var cleanPrice = (defaultFormattedPrice || '').replace(/<[^>]*>?/gm, '').trim();
  // Remove trailing .00 / ,00 (keeps real cents like .50)
  cleanPrice = cleanPrice.replace(/[.,]00(?=\D*$)/, '');
  return '<span class="money">' + cleanPrice + '</span>';
}

  $(document).on('click', '.vr-swatch', function () {
    const $swatch = $(this);
    $('.vr-swatch').removeClass('vr-swatch--active');
    $swatch.addClass('vr-swatch--active');

    const title = $swatch.attr('data-title');
    const specs = $swatch.attr('data-specs');
    const price = $swatch.attr('data-price');
    const priceRaw = parseInt($swatch.attr('data-price-raw'), 10) || 0;
    const stock = $swatch.attr('data-stock');
    const imageSrc = $swatch.attr('data-image');
    const linkHref = $swatch.attr('data-link');
    const variantUrl = $swatch.attr('data-url');
    const variantId = $swatch.attr('data-id');
    const $watchBuyLink = $('#vr-watch-buy-link');
    const $watchTitle = $('#vr-watch-title');
    const $watchSpecs = $('#vr-watch-specs');
    const $watchPrice = $('#vr-watch-price');
    const $watchImage = $('#vr-watch-image');

    if (variantId && $watchBuyLink.length) {
      $watchBuyLink.attr('data-variant-id', variantId);
    }

    if (variantUrl) {
      if ($watchBuyLink.length) $watchBuyLink.attr('href', variantUrl);
      $('.vr-product-showcase__watch-name, .vr-product-showcase__image-wrapper a').attr('href', variantUrl);
    }

    if (title && $watchTitle.length) $watchTitle.text(title);
    if (specs && $watchSpecs.length) $watchSpecs.html(specs);

    if (price && $watchPrice.length) {
      var convertedHtml = formatShowcasePrice(priceRaw, price);
      $watchPrice.html(convertedHtml);
      $watchPrice.attr('data-base-price', priceRaw);

      // Programmatically trigger the currency converter re-selection
      reselectActiveCurrency();
      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(reselectActiveCurrency);
      }
      setTimeout(reselectActiveCurrency, 50);
      setTimeout(reselectActiveCurrency, 150);
    }
    if (linkHref && $watchBuyLink.length) $watchBuyLink.attr('href', linkHref);

    if (imageSrc && $watchImage.length) {
      $watchImage.css('opacity', '0');
      setTimeout(function () {
        $watchImage.attr('src', imageSrc).css('opacity', '1');
      }, 300);
    }
  });



  // Scroll Animations (IntersectionObserver)
  if ('IntersectionObserver' in window) {
    const observerOptions = { root: null, rootMargin: '0px', threshold: 0.15 };
    const observer = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          $(entry.target).addClass('vr-is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, observerOptions);

    $('.vr-animate').each(function () {
      observer.observe(this);
    });
  }

  // Right Machine Scroll & Progress Track
  const $rightMachineSec = $('#vr-right-machine');
  const $rightMachineTrack = $('.vr-right-machine__track');
  const $rightMachineProgress = $('#vr-right-machine-progress');
  const $firstImageWrap = $('.vr-right-machine__image-wrap');
  const $firstNumWrap = $('.vr-right-machine__num-text');
  const $firstDotWrap = $('.vr-right-machine__dot-wrap');
  const $timelineSteps = $('.vr-right-machine__step');

  function updateTrackPosition() {
    if ($(window).width() <= 991) return;
    if (!$firstImageWrap.length || !$firstNumWrap.length || !$firstDotWrap.length || !$rightMachineTrack.length) return;
    const imgHeight = $firstImageWrap.outerHeight();
    const numHeight = $firstNumWrap.outerHeight();
    const gap1 = 32, gap2 = 32, dotCenter = 6;
    $rightMachineTrack.css('top', (imgHeight + gap1 + numHeight + gap2 + dotCenter) + 'px');
  }

  function handleRightMachineScroll() {
    if (!$rightMachineSec.length || !$rightMachineProgress.length) return;
    if ($(window).width() <= 991) return;

    const secOffset = $rightMachineSec.offset().top;
    const scrollTop = $(window).scrollTop();
    const rectTop = secOffset - scrollTop;
    const secHeight = $rightMachineSec.outerHeight();
    const winHeight = $(window).height();
    const scrollEnd = -(secHeight - winHeight);

    let percentage = 0;
    if (rectTop > 0) percentage = 0;
    else if (rectTop <= scrollEnd) percentage = 100;
    else {
      const scrolled = Math.abs(rectTop);
      const totalScroll = secHeight - winHeight;
      percentage = (scrolled / totalScroll) * 100;
    }

    $rightMachineProgress.css('width', percentage + '%');

    $timelineSteps.each(function (index) {
      const threshold = index * 25;
      if (percentage >= threshold) $(this).addClass('is-active');
      else $(this).removeClass('is-active');
    });
  }

  if ($rightMachineSec.length) {
    updateTrackPosition();
    $(window).on('resize', updateTrackPosition);
    $(window).on('scroll', handleRightMachineScroll);

    let rightMachineSwiper;

    function initRightMachineSwiper() {
      const isMobile = $(window).width() <= 991;

      if (isMobile && !rightMachineSwiper) {
        rightMachineSwiper = new Swiper('#vr-right-machine-swiper', {
          slidesPerView: 'auto',
          spaceBetween: 16,
          on: {
            progress: function (swiper, progress) {
              const $mobileProgress = $('#vr-right-machine-mobile-progress');
              const $mobileNums = $('.vr-right-machine__mobile-num');
              const $mobileDots = $('.vr-right-machine__mobile-dot-wrap');
              const total = $mobileNums.length;

              if ($mobileProgress.length) {
                $mobileProgress.css('width', (progress * 100) + '%');
              }

              const activeIndex = Math.round(progress * (total - 1));
              $mobileNums.each(function (index) {
                if (index <= activeIndex) $(this).addClass('is-active');
                else $(this).removeClass('is-active');
              });
              $mobileDots.each(function (index) {
                if (index <= activeIndex) $(this).addClass('is-active');
                else $(this).removeClass('is-active');
              });
            }
          }
        });
      } else if (!isMobile && rightMachineSwiper) {
        rightMachineSwiper.destroy(true, true);
        rightMachineSwiper = null;
      }
    }

    initRightMachineSwiper();
    $(window).on('resize', initRightMachineSwiper);
  }

  // Excellence Section Accordion & Scroll Logic
  // Excellence Section Accordion & Click Logic
  const $excellenceSec = $('.vr-excellence');
  const $excellenceItems = $('.vr-excellence__item');
  const $excellenceDesktops = $('.vr-excellence__visuals--desktop .vr-excellence__item-body');

  // Unified Click Handler for both Mobile and Desktop
  $excellenceItems.each(function (index) {
    const $item = $(this);
    const $header = $item.find('.vr-excellence__item-header');
    if (!$header.length) return;

    $header.on('click', function () {
      const isDesktop = $(window).width() > 991;
      const isActive = $item.hasClass('is-active');

      if (isDesktop) {
        // Desktop: Click to activate corresponding item and visual
        $excellenceItems.removeClass('is-active').find('.vr-excellence__item-header').attr('aria-expanded', 'false');
        $excellenceDesktops.removeClass('is-active');

        $item.addClass('is-active');
        $header.attr('aria-expanded', 'true');

        // Activate the matching desktop visual by index
        $excellenceDesktops.eq(index).addClass('is-active');
      } else {
        // Mobile: Accordion toggle behavior
        if (isActive) {
          $item.removeClass('is-active');
          $header.attr('aria-expanded', 'false');
        } else {
          $excellenceItems.removeClass('is-active').find('.vr-excellence__item-header').attr('aria-expanded', 'false');
          $item.addClass('is-active');
          $header.attr('aria-expanded', 'true');
        }
      }
    });
  });

  // Scroll Handler (Restricted strictly to mobile viewports now)
  /*
  function handleExcellenceScroll() {
    if (!$excellenceSec.length || !$excellenceItems.length) return;
    if ($(window).width() > 991) return; // Disabled for desktop
  
    const secOffset = $excellenceSec.offset().top;
    const scrollTop = $(window).scrollTop();
    const rectTop = secOffset - scrollTop;
    const secHeight = $excellenceSec.outerHeight();
    const winHeight = $(window).height();
    const scrollEnd = -(secHeight - winHeight);
  
    let percentage = 0;
    if (rectTop > 0) percentage = 0;
    else if (rectTop <= scrollEnd) percentage = 100;
    else {
      const scrolled = Math.abs(rectTop);
      const totalScroll = secHeight - winHeight;
      percentage = (scrolled / totalScroll) * 100;
    }
  
    const numItems = $excellenceItems.length;
    const segment = 100 / numItems;
  
    let activeIndex = Math.floor(percentage / segment);
    if (activeIndex >= numItems) activeIndex = numItems - 1;
    if (activeIndex < 0) activeIndex = 0;
  
    $excellenceItems.each(function(i) {
      if (i === activeIndex) $(this).addClass('is-active');
      else $(this).removeClass('is-active');
    });
  
    $excellenceDesktops.each(function(i) {
      if (i === activeIndex) $(this).addClass('is-active');
      else $(this).removeClass('is-active');
    });
  }
    */

  // Initialize scroll event only if section exists
  // if ($excellenceSec.length) {
  //   $(window).on('scroll', handleExcellenceScroll);
  //   handleExcellenceScroll();
  // }

  // Header Scroll & Mobile Navigation
  const $headerEl = $('.vr-header');
  function handleHeaderScroll() {
    if (!$headerEl.length) return;
    if ($(window).scrollTop() > 50) $headerEl.addClass('vr-header--scrolled');
    else $headerEl.removeClass('vr-header--scrolled');
  }

  $(window).on('scroll', handleHeaderScroll);
  handleHeaderScroll();

  const $menuToggle = $('.vr-header__menu-toggle');
  const $mobileMenu = $('#vr-mobile-menu');
  const $menuIcon = $menuToggle.find('.vr-icon--menu');
  const $closeIcon = $menuToggle.find('.vr-icon--close');

  if ($menuToggle.length && $mobileMenu.length) {
    function closeMobileMenu() {
      $mobileMenu.removeClass('is-active').attr('aria-hidden', 'true');
      $headerEl.removeClass('vr-header--menu-open');
      $menuToggle.attr('aria-expanded', 'false');
      if ($menuIcon.length) $menuIcon.show();
      if ($closeIcon.length) $closeIcon.hide();
      $('body').removeClass('vr-body-lock');
    }

    $menuToggle.on('click', function () {
      const isOpen = $mobileMenu.hasClass('is-active');

      if (isOpen) {
        closeMobileMenu();
      } else {
        $mobileMenu.addClass('is-active').attr('aria-hidden', 'false');
        $headerEl.addClass('vr-header--menu-open');
        $menuToggle.attr('aria-expanded', 'true');
        if ($menuIcon.length) $menuIcon.hide();
        if ($closeIcon.length) $closeIcon.show();
        $('body').addClass('vr-body-lock');
      }
    });

    $mobileMenu.find('.vr-mobile-menu__link:not(.vr-mobile-menu__link--toggle)').on('click', closeMobileMenu);
    $mobileMenu.find('.vr-mobile-menu__dropdown-link').on('click', closeMobileMenu);

    const $dropdownToggle = $mobileMenu.find('.vr-mobile-menu__link--toggle');
    const $dropdownItem = $mobileMenu.find('.vr-mobile-menu__item--has-dropdown');
    const $dropdownMenu = $mobileMenu.find('.vr-mobile-menu__dropdown');

    if ($dropdownToggle.length && $dropdownItem.length && $dropdownMenu.length) {
      $dropdownToggle.on('click', function (e) {
        e.stopPropagation();
        const isOpen = $dropdownItem.hasClass('is-open');
        if (isOpen) {
          $dropdownItem.removeClass('is-open');
          $dropdownToggle.attr('aria-expanded', 'false');
          $dropdownMenu.attr('aria-hidden', 'true');
        } else {
          $dropdownItem.addClass('is-open');
          $dropdownToggle.attr('aria-expanded', 'true');
          $dropdownMenu.attr('aria-hidden', 'false');
        }
      });
    }
  }

  // Static Swipers Initialization
  if (typeof Swiper !== 'undefined') {
    if ($('.vr-marquee-slider').length) {
      new Swiper('.vr-marquee-slider', {
        loop: true,
        freeMode: false,
        spaceBetween: 32,
        slidesPerView: 'auto',
        speed: 10000,
        autoplay: { delay: 0, disableOnInteraction: false },
        allowTouchMove: false
      });
    }

    if ($('.vr-revolution__slider').length) {
      new Swiper('.vr-revolution__slider', {
        slidesPerView: 'auto',
        spaceBetween: 32,
        grabCursor: true,
        breakpoints: {
          320: { spaceBetween: 16 },
          768: { spaceBetween: 24 },
          1024: { spaceBetween: 32 }
        }
      });
    }

    if ($('.vr-about-search__slider').length) {
      new Swiper('.vr-about-search__slider', {
        slidesPerView: 'auto',
        spaceBetween: 32,
        grabCursor: true,
        breakpoints: {
          320: { spaceBetween: 16 },
          768: { spaceBetween: 24 },
          1024: { spaceBetween: 32 }
        }
      });
    }
  }

  // About Page Reviews Mobile Slider
  let aboutReviewsSwiper = null;

  function initAboutReviewsSlider() {
    const $sliderEl = $('.vr-about-reviews__slider');
    if (!$sliderEl.length) return;

    if ($(window).width() <= 767) {
      if (!aboutReviewsSwiper) {
        aboutReviewsSwiper = new Swiper($sliderEl[0], {
          slidesPerView: 'auto',
          spaceBetween: 16,
          slidesOffsetAfter: 16,
          grabCursor: true,
          watchOverflow: true,
        });
      }
    } else {
      if (aboutReviewsSwiper) {
        aboutReviewsSwiper.destroy(true, true);
        aboutReviewsSwiper = null;
      }
    }
  }

  if ($('.vr-about-reviews__slider').length) {
    initAboutReviewsSlider();
    $(window).on('resize', initAboutReviewsSlider);
  }

  // UGC Item Video Hover / Mobile Actions
  $('.vr-join-vyron__item').each(function () {
    const $item = $(this);
    const video = $item.find('.vr-join-vyron__video')[0];

    if (!video) return;

    // Play this video and pause all other videos
    function playVideo() {
      $('.vr-join-vyron__video').each(function () {
        if (this !== video) {
          this.pause();
        }
      });

      video.muted = true;

      video.play().catch(function (error) {
        console.log('Video play failed:', error);
      });
    }

    // Desktop hover
    $item.on('mouseenter', function () {
      playVideo();
    });

    // Desktop leave
    $item.on('mouseleave', function () {
      video.pause();
    });

    // Mobile click
    $item.on('click', function () {
      playVideo();
    });
  });

  // About Video Element Autoplay
  const $aboutVideoElement = $('.vr-about-video__element');
  if ($aboutVideoElement.length) {
    const video = $aboutVideoElement[0];
    video.muted = true;
    video.play().catch(function () { });
  }

  // Dynamic Swiper initialization for Join Vyron UGC section
  const joinVyronSwipers = new Map();

  function initJoinVyronSliders() {
    $('.vr-join-vyron__slider').each(function () {
      const sliderEl = this;
      const $sliderEl = $(sliderEl);
      const $wrapperEl = $sliderEl.find('.vr-join-vyron__wrapper');
      const $items = $sliderEl.find('.vr-join-vyron__item');
      if (!$wrapperEl.length || !$items.length) return;

      const containerWidth = $sliderEl.width();
      const gap = $(window).width() > 1024 ? 32 : ($(window).width() >= 768 ? 24 : 16);

      let totalWidth = 0;
      $items.each(function (idx) {
        totalWidth += $(this).outerWidth();
        if (idx < $items.length - 1) totalWidth += gap;
      });

      let swiperInstance = joinVyronSwipers.get(sliderEl);

      if (totalWidth > containerWidth) {
        if (!swiperInstance) {
          swiperInstance = new Swiper(sliderEl, {
            slidesPerView: 'auto',
            spaceBetween: gap,
            grabCursor: true,
            watchOverflow: true,
          });
          joinVyronSwipers.set(sliderEl, swiperInstance);
        } else {
          swiperInstance.params.spaceBetween = gap;
          swiperInstance.update();
        }
      } else {
        if (swiperInstance) {
          swiperInstance.destroy(true, true);
          joinVyronSwipers.delete(sliderEl);
        }
      }
    });
  }

  if ($('.vr-join-vyron__slider').length) {
    initJoinVyronSliders();
    $(window).on('resize', initJoinVyronSliders);
  }

  // Swiper initialization for Seen In Logos section (Always slider, auto-slide & loop)
  const seenSwipers = new Map();

  function initSeenSliders() {
    $('.vr-seen__slider').each(function () {
      const sliderEl = this;
      if (seenSwipers.has(sliderEl)) return; // already initialized

      const $wrapperEl = $(sliderEl).find('.vr-seen__logos');
      if (!$wrapperEl.length) return;

      // Pre-duplicate slides so Swiper always has enough content for loop
      const $originals = $wrapperEl.children().not('.is-clone');
      if ($originals.length > 0 && $originals.length < 20) {
        const repeatCount = Math.ceil(20 / $originals.length);
        for (let i = 1; i < repeatCount; i++) {
          $originals.each(function () {
            $wrapperEl.append($(this).clone(true).addClass('is-clone'));
          });
        }
      }

      const instance = new Swiper(sliderEl, {
        loop: true,
        freeMode: false,
        spaceBetween: 32,
        slidesPerView: 'auto',
        speed: 4000,
        autoplay: { delay: 0, disableOnInteraction: false },
        allowTouchMove: false,
        breakpoints: {
          320: { spaceBetween: 16 },
          768: { spaceBetween: 24 },
          1024: { spaceBetween: 32 }
        }
      });

      seenSwipers.set(sliderEl, instance);
    });
  }

  if ($('.vr-seen__slider').length) {
    // Images now have explicit width/height in HTML — Swiper can measure immediately, no load delay needed
    initSeenSliders();

    // Theme editor: re-init when a section is added / selected
    $(document).on('shopify:section:load shopify:section:select', function (e) {
      const $section = $(e.target);
      if ($section.find('.vr-seen__slider').length || $section.hasClass('vr-seen__slider')) {
        const $sliders = $section.hasClass('vr-seen__slider') ? $section : $section.find('.vr-seen__slider');
        $sliders.each(function () {
          const prev = seenSwipers.get(this);
          if (prev) { prev.destroy(true, true); seenSwipers.delete(this); }
          $(this).find('.vr-seen__logos .is-clone').remove();
        });
        initSeenSliders();
      }
    });
  }



  // Details Page: Engineered for Excellence Slider (Perfect Smooth Infinite Marquee Auto Play)
  const $excellenceSliderEl = $('.vr-details-excellence__slider');
  if ($excellenceSliderEl.length) {
    const $wrapper = $excellenceSliderEl.find('.swiper-wrapper');

    if ($wrapper.length) {
      $wrapper.find('.is-clone').remove();

      const $originalSlides = $wrapper.children().not('.is-clone');

      if ($originalSlides.length > 0) {
        $originalSlides.each(function () {
          const $clone = $(this).clone(true).addClass('is-clone');
          $wrapper.append($clone);
        });

        let currentX = 0;
        let isPaused = false;
        let isDragging = false;
        let startX = 0;
        let dragStartX = 0;
        let lastX = 0;
        let velocity = 0;
        const speed = 1.2;

        function getGap() {
          const gapVal = parseFloat($wrapper.css('gap'));
          if (!isNaN(gapVal)) return gapVal;
          const w = $(window).width();
          if (w < 768) return 16;
          if (w < 1024) return 24;
          return 32;
        }

        function getHalfWidth() {
          const gap = getGap();
          let totalWidth = 0;
          $originalSlides.each(function () {
            totalWidth += $(this).outerWidth() + gap;
          });
          return totalWidth;
        }

        function render() {
          const halfWidth = getHalfWidth();
          if (halfWidth > 0) {
            if (currentX <= -halfWidth) {
              currentX += halfWidth;
            } else if (currentX > 0) {
              currentX -= halfWidth;
            }
            $wrapper.css('transform', 'translate3d(' + currentX + 'px, 0, 0)');
          }
        }

        function animate() {
          if (isDragging) {
            // Active dragging handled in pointermove
          } else if (Math.abs(velocity) > 0.05) {
            currentX += velocity;
            velocity *= 0.92;
            render();
          } else if (!isPaused) {
            currentX -= speed;
            render();
          }
          requestAnimationFrame(animate);
        }

        requestAnimationFrame(animate);

        $excellenceSliderEl.on('mouseenter', function () {
          if (!isDragging) isPaused = true;
        });

        $excellenceSliderEl.on('mouseleave', function () {
          if (!isDragging) isPaused = false;
        });

        const $nextBtn = $('.vr-details-excellence__nav-btn--next');
        const $prevBtn = $('.vr-details-excellence__nav-btn--prev');

        if ($nextBtn.length) {
          $nextBtn.on('click', function (e) {
            e.preventDefault();
            velocity = -15;
          });
        }

        if ($prevBtn.length) {
          $prevBtn.on('click', function (e) {
            e.preventDefault();
            velocity = 15;
          });
        }

        $wrapper.css('cursor', 'grab');

        const excellenceDomEl = $excellenceSliderEl[0];

        $excellenceSliderEl.on('pointerdown', function (e) {
          isDragging = true;
          isPaused = true;
          startX = e.clientX;
          lastX = e.clientX;
          dragStartX = currentX;
          velocity = 0;
          $wrapper.css('cursor', 'grabbing');
          try {
            if (excellenceDomEl && excellenceDomEl.setPointerCapture) {
              excellenceDomEl.setPointerCapture(e.originalEvent ? e.originalEvent.pointerId : e.pointerId);
            }
          } catch (err) { }
        });

        $excellenceSliderEl.on('pointermove', function (e) {
          if (!isDragging) return;
          const clientX = e.clientX || (e.originalEvent && e.originalEvent.clientX);
          const deltaX = clientX - startX;
          velocity = clientX - lastX;
          lastX = clientX;
          currentX = dragStartX + deltaX;
          render();
        });

        function endDrag(e) {
          if (isDragging) {
            isDragging = false;
            isPaused = false;
            $wrapper.css('cursor', 'grab');
            try {
              const pId = e.pointerId || (e.originalEvent && e.originalEvent.pointerId);
              if (pId && excellenceDomEl && excellenceDomEl.releasePointerCapture) {
                excellenceDomEl.releasePointerCapture(pId);
              }
            } catch (err) { }
          }
        }

        $excellenceSliderEl.on('pointerup pointercancel', endDrag);
      }
    }
  }

  // Details Page: Join The VYRON Revolution Slider (UGC)
  if ($('.vr-details-reviews__slider').length) {
    new Swiper('.vr-details-reviews__slider', {
      slidesPerView: 'auto',
      grabCursor: true
    });
  }

  // Specifications Tabs & Drag-to-Scroll Logic
  const $specNavWrapper = $('.vr-specs__nav-wrapper');
  if ($specNavWrapper.length) {
    let isDown = false;
    let startX;
    let scrollLeft;
    let moved = false;

    $specNavWrapper.on('mousedown', function (e) {
      isDown = true;
      moved = false;
      $specNavWrapper.addClass('is-dragging');
      startX = e.pageX - $specNavWrapper.offset().left;
      scrollLeft = $specNavWrapper.scrollLeft();
    });

    $specNavWrapper.on('mouseleave mouseup', function () {
      isDown = false;
      $specNavWrapper.removeClass('is-dragging');
    });

    $specNavWrapper.on('mousemove', function (e) {
      if (!isDown) return;
      const x = e.pageX - $specNavWrapper.offset().left;
      const walk = (x - startX) * 1.5;
      if (Math.abs(walk) > 5) {
        moved = true;
      }
      $specNavWrapper.scrollLeft(scrollLeft - walk);
    });

    $specNavWrapper.on('click', function (e) {
      if (moved) {
        e.preventDefault();
        e.stopPropagation();
      }
    });
  }

  const $specTabs = $('.vr-specs__nav-btn');
  const $specPanes = $('.vr-specs__pane');

  if ($specTabs.length > 0 && $specPanes.length > 0) {
    $specTabs.on('click', function () {
      const $this = $(this);
      $specTabs.removeClass('vr-specs__nav-btn--active');
      $this.addClass('vr-specs__nav-btn--active');

      $specPanes.removeClass('vr-specs__pane--active');

      const targetId = $this.attr('data-target');
      $('#' + targetId).addClass('vr-specs__pane--active');
    });
  }

  // FAQ Item Accordion Logic
  $('.vr-faq__item-header').on('click', function () {
    const $header = $(this);
    const $item = $header.closest('.vr-faq__item');
    const isActive = $item.hasClass('vr-faq__item--active');

    $('.vr-faq__item').removeClass('vr-faq__item--active')
      .find('.vr-faq__item-header').attr('aria-expanded', 'false');

    if (!isActive) {
      $item.addClass('vr-faq__item--active');
      $header.attr('aria-expanded', 'true');
    }
  });

  // Featured In Logos Swiper
  if ($('.vr-featured__slider-wrap').length) {
    new Swiper('.vr-featured__slider-wrap', {
      slidesPerView: 'auto',
      grabCursor: true,
      centerInsufficientSlides: true,
      breakpoints: {
        320: { slidesOffsetBefore: 16, slidesOffsetAfter: 16 },
        768: { slidesOffsetBefore: 32, slidesOffsetAfter: 32 },
        1024: { slidesOffsetBefore: 0, slidesOffsetAfter: 0 }
      }
    });
  }

  // Beyond The Dial Swiper
  if ($('.vr-beyond-dial__slider').length) {
    new Swiper('.vr-beyond-dial__slider', {
      slidesPerView: 3,
      spaceBetween: 32,
      grabCursor: true,
      navigation: {
        nextEl: '.vr-beyond-dial__arrow--next',
        prevEl: '.vr-beyond-dial__arrow--prev',
      },
      breakpoints: {
        320: { slidesPerView: 1.15, spaceBetween: 16 },
        576: { slidesPerView: 1.6, spaceBetween: 20 },
        768: { slidesPerView: 2.2, spaceBetween: 24 },
        1024: { slidesPerView: 3, spaceBetween: 32 }
      }
    });
  }

  // FAQ Category Filter
  $('.vr-faq__filter-btn').on('click', function () {
    const filterValue = $(this).attr('data-filter');
    $('.vr-faq__filter-btn').removeClass('vr-faq__filter-btn--active');
    $(this).addClass('vr-faq__filter-btn--active');

    if (filterValue === 'all') {
      $('.vr-faq__accordion').fadeIn(300);
    } else {
      $('.vr-faq__accordion').hide();
      $('.vr-faq__accordion[data-category="' + filterValue + '"]').fadeIn(300);
    }
  });

  // FAQ Accordion Toggle
  $('.vr-faq__accordion-header').off('click').on('click', function (e) {
    e.preventDefault();
    const $item = $(this).parent('.vr-faq__accordion');
    const $body = $(this).next('.vr-faq__accordion-body');
    const isActive = $item.hasClass('vr-faq__accordion--active');

    $('.vr-faq__accordion').not($item).removeClass('vr-faq__accordion--active');
    $('.vr-faq__accordion').not($item).find('.vr-faq__accordion-body').stop(true, true).slideUp(300);

    if (!isActive) {
      $item.addClass('vr-faq__accordion--active');
      $body.stop(true, true).slideDown(300);
    } else {
      $item.removeClass('vr-faq__accordion--active');
      $body.stop(true, true).slideUp(300);
    }
  });

  // Collection Page Mobile Filter Drawer
  $('#vr-collection-filter-trigger').on('click', function () {
    $('#vr-collection-drawer').addClass('vr-collection__drawer--open');
    $('#vr-collection-drawer-overlay').addClass('vr-collection__drawer-overlay--open');
    $('body').css('overflow', 'hidden');
  });

  function closeCollectionDrawer() {
    $('#vr-collection-drawer').removeClass('vr-collection__drawer--open');
    $('#vr-collection-drawer-overlay').removeClass('vr-collection__drawer-overlay--open');
    $('body').css('overflow', '');
  }

  $('#vr-collection-drawer-close, #vr-collection-drawer-overlay, #vr-collection-drawer-apply').on('click', function () {
    closeCollectionDrawer();
  });


  // Reviews Page Inline Video Toggle
  // 1. Play/Pause toggle on video card media click
  $('.vr-reviews__card-media').on('click', function (e) {
    e.preventDefault();
    const $media = $(this);
    const $card = $media.closest('.vr-reviews__card');
    const video = $media.find('video')[0];

    if (video) {
      if (video.paused) {
        const playPromise = video.play();
        $card.addClass('is-playing');
        if (playPromise !== undefined) {
          playPromise.catch(function (error) {
            console.error("Video play failed:", error);
            $card.removeClass('is-playing');
          });
        }
      } else {
        video.pause();
        $card.removeClass('is-playing');
      }
    }
  });

  // 2. Mute/Unmute toggle (Stops bubbling AND auto-plays video if unmuted)
  $(document).on('click', '.vr-reviews__mute-btn', function (e) {
    e.stopPropagation(); // Stops the click from bubbling up to the card

    const $wrapper = $(this).closest('.vr-reviews__card-media');
    const $card = $wrapper.closest('.vr-reviews__card');
    const $video = $wrapper.find('video');
    const videoElement = $video[0];

    if (!videoElement) return;

    // const $mutedIcon = $(this).find('.icon-muted');
    // const $unmutedIcon = $(this).find('.icon-unmuted');

    // if (videoElement.muted) {
    //   // Unmuting: turn off mute, switch icon, and play video if paused
    //   videoElement.muted = false;
    //   $mutedIcon.hide();
    //   $unmutedIcon.show();
    // } else {
    //   // Muting: just toggle mute state and icon
    //   videoElement.muted = true;
    //   $mutedIcon.show();
    //   $unmutedIcon.hide();

    // }
    if (videoElement.paused) {
      const playPromise = videoElement.play();
      $card.addClass('is-playing');
      if (playPromise !== undefined) {
        playPromise.catch(function (error) {
          console.error("Video play failed:", error);
        });
      }
    }
  });

  // 3. Video Play event listener
  $('.vr-reviews__card video').on('play', function () {
    // $(this).closest('.vr-reviews__card').find('.vr-reviews__mute-btn').css('display', 'flex');
    $(this).closest('.vr-reviews__card').addClass('is-playing');
  });

  // 4. Video Pause/Ended event listener
  $('.vr-reviews__card video').on('pause ended', function () {
    // $(this).closest('.vr-reviews__card').find('.vr-reviews__mute-btn').css('display', 'none');
    $(this).closest('.vr-reviews__card').removeClass('is-playing');
  });
  //================================

  // Custom Dropdown Component Functionality
  $('.vr-custom-dropdown__trigger').on('click', function (e) {
    e.stopPropagation();
    const $dropdown = $(this).closest('.vr-custom-dropdown');
    const isOpen = $dropdown.hasClass('is-open');

    $('.vr-custom-dropdown').not($dropdown).removeClass('is-open')
      .find('.vr-custom-dropdown__trigger').attr('aria-expanded', 'false');

    if (isOpen) {
      $dropdown.removeClass('is-open');
      $(this).attr('aria-expanded', 'false');
    } else {
      $dropdown.addClass('is-open');
      $(this).attr('aria-expanded', 'true');
    }
  });

  $('.vr-custom-dropdown__option').on('click', function (e) {
    e.stopPropagation();
    const $option = $(this);
    const $dropdown = $option.closest('.vr-custom-dropdown');
    const selectedText = $option.text();

    $dropdown.find('.vr-custom-dropdown__option').removeClass('is-selected');
    $option.addClass('is-selected');

    $dropdown.find('.vr-custom-dropdown__selected-text').text(selectedText);
    $dropdown.removeClass('is-open');
    $dropdown.find('.vr-custom-dropdown__trigger').attr('aria-expanded', 'false');
  });

  $(document).on('click', function () {
    $('.vr-custom-dropdown').removeClass('is-open')
      .find('.vr-custom-dropdown__trigger').attr('aria-expanded', 'false');
  });
});

